if (!customElements.get('pop-announcement')) {
  customElements.define('pop-announcement', class extends HTMLElement {
    connectedCallback() {
      this.messages = Array.from(this.querySelectorAll('[data-message]'));
      this.index = 0;
      if (this.messages.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = window.setInterval(() => {
        if (document.hidden || this.matches(':hover') || this.contains(document.activeElement)) return;
        this.messages[this.index].hidden = true;
        this.index = (this.index + 1) % this.messages.length;
        this.messages[this.index].hidden = false;
      }, 5000);
    }
    disconnectedCallback() { window.clearInterval(this.timer); }
  });
}
